export const TOKEN = 'TOKEN';
export const LANGUAGE = 'LANGUAGE';
